import { parseRemindAtValue } from "./notesReminderUtils";

export const NOTES_WIDGET_ENABLED_KEY = "notes_widget_enabled";
export const NOTES_WIDGET_OPEN_KEY = "notes_widget_open";
export const NOTES_WIDGET_POSITION_KEY = "notes_widget_position";
export const NOTES_WIDGET_SIZE_KEY = "notes_widget_size";
export const NOTES_WIDGET_NOTES_KEY = "notes_widget_notes";

const DEFAULT_POSITION = { x: 24, y: 80 };
const DEFAULT_SIZE = { width: 360, height: 420 };

function safeParseJson(raw, fallback) {
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function readNotesWidgetEnabled() {
  const raw = localStorage.getItem(NOTES_WIDGET_ENABLED_KEY);
  if (raw === "false") {
    return false;
  }
  if (raw === "true") {
    return true;
  }
  return true;
}

export function writeNotesWidgetEnabled(value) {
  localStorage.setItem(NOTES_WIDGET_ENABLED_KEY, value ? "true" : "false");
}

export function readNotesWidgetOpen() {
  return localStorage.getItem(NOTES_WIDGET_OPEN_KEY) === "true";
}

export function writeNotesWidgetOpen(value) {
  localStorage.setItem(NOTES_WIDGET_OPEN_KEY, value ? "true" : "false");
}

export function readNotesWidgetPosition() {
  const parsed = safeParseJson(
    localStorage.getItem(NOTES_WIDGET_POSITION_KEY),
    DEFAULT_POSITION,
  );
  const x = Number(parsed?.x);
  const y = Number(parsed?.y);
  return {
    x: Number.isFinite(x) ? x : DEFAULT_POSITION.x,
    y: Number.isFinite(y) ? y : DEFAULT_POSITION.y,
  };
}

export function writeNotesWidgetPosition(position) {
  try {
    localStorage.setItem(
      NOTES_WIDGET_POSITION_KEY,
      JSON.stringify({
        x: Number(position.x) || 0,
        y: Number(position.y) || 0,
      }),
    );
  } catch (e) {
    console.error("notesWidgetStorage: failed to save position", e);
  }
}

export function readNotesWidgetSize() {
  const parsed = safeParseJson(
    localStorage.getItem(NOTES_WIDGET_SIZE_KEY),
    DEFAULT_SIZE,
  );
  const width = Number(parsed?.width);
  const height = Number(parsed?.height);
  return {
    width: Number.isFinite(width) ? width : DEFAULT_SIZE.width,
    height: Number.isFinite(height) ? height : DEFAULT_SIZE.height,
  };
}

export function writeNotesWidgetSize(size) {
  try {
    localStorage.setItem(
      NOTES_WIDGET_SIZE_KEY,
      JSON.stringify({
        width: Number(size.width) || DEFAULT_SIZE.width,
        height: Number(size.height) || DEFAULT_SIZE.height,
      }),
    );
  } catch (e) {
    console.error("notesWidgetStorage: failed to save size", e);
  }
}

/**
 * @returns {{ id: string, text: string, remindAt: number | null, dismissedForRemindAt: number | null, reminderEnabled: boolean }[]}
 */
export function readNotesList() {
  const parsed = safeParseJson(localStorage.getItem(NOTES_WIDGET_NOTES_KEY), []);
  if (!Array.isArray(parsed)) {
    return [];
  }
  return parsed
    .filter((n) => n && typeof n.id === "string")
    .map((n) => ({
      id: n.id,
      text: typeof n.text === "string" ? n.text : "",
      remindAt: parseRemindAtValue(n.remindAt),
      dismissedForRemindAt: parseRemindAtValue(n.dismissedForRemindAt),
      reminderEnabled: n.reminderEnabled === true,
    }));
}

export function writeNotesList(notes) {
  try {
    localStorage.setItem(NOTES_WIDGET_NOTES_KEY, JSON.stringify(notes));
  } catch (e) {
    console.error("notesWidgetStorage: failed to save notes", e);
  }
}

export function createNoteId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `note-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
